<template>
  <div id="topbar" :class="{ float: type === 'float', 'show-menu': showMenu }">
    <wrap class="lg">
      <route class="main-logo" to="Index" :exact="true">
        <img src="/static/images/jobcarda-logo.png"/>
        <span>
          Jobcarda
        </span>
      </route>
      <div id="hamburger" @click="showMenu = !showMenu">
        <icon :name="showMenu ? 'cross' : 'menu'"/>
      </div>
      <div id="menu" :class="{ show: showMenu }">
        <template v-for="item in menu">
          <route v-if="item.to" :key="item.to" :to="item.to" :exact="isExact(item)">
            <icon v-if="item.icon" :name="item.icon"/>
            {{ item.name }}
          </route>
          <a v-if="item.href" :key="item.to" :href="item.href">
            {{ item.name }}
          </a>
        </template>
        <template v-if="isAuth">
          <route class="user-menu" to="Board">
            {{ meeting }},
            {{ _user.firstName }}
          </route>
          <btn class="btn danger lg round ib" @click="logout" title="Log out">
            <icon name="lock"/> Logout
          </btn>
        </template>
        <template v-else>
          <route class="btn warning inv lg round ib" to="Login">
            Login
          </route>
          <route class="btn warning lg round ib" to="Signup">
            Signup
          </route>
        </template>
      </div>
    </wrap>
  </div>
</template>

<script>
import { actions, getters, randomInArray } from '../utils'
// import Sticky from '../mixins/Sticky'

export default {
  // mixins: [Sticky],
  props: {
    type: {
      default: 'static',
    },
  },
  data() {
    return {
      // stickyThreshold: 80,
      showMenu: false,
      menu: [
        // {
        //   to: 'Board',
        //   name: 'Board',
        // },
        // {
        //   href: '/',
        //   name: 'External Link',
        // },
        // {
        //   to: 'LocalPath',
        //   name: 'Local Link',
        // },
      ],
    }
  },
  computed: {
    meeting() {
      return randomInArray([
        'Welcome back',
        'Hello',
        'Hey',
        'Nice seeing you again',
        'You\'re lookin\' swell',
      ])
    },
    ...getters(),
  },
  methods: {
    isExact: item => typeof item.exact !== 'undefined' ? item.exact : false,
    logout() {
      this.LOGOUT()
      this.$router.push({ name: 'Index' })
    },
    ...actions('LOGOUT'),
  },
}
</script>

<style lang="scss">
@import '~style/variables';

#menu {
  float: right;
  padding: 1rem 0;
  a {
    @include trans;
    display: inline-block;
  }
  .btn {
    padding: 0.75rem 1rem;
    &.warning.inv {
      margin-right: 0.5rem;
    }
  }
  .user-menu {
    color: $c-danger;
    padding: 0.75rem 0.5rem;
  }
  @media screen and (max-width: $res-sm) {
    display: none;
    &.show {
      display: block;
      text-align: center;
      width: 100%;
      a {
        margin: 0;
      }
    }
  }
  @media screen and (min-width: $res-lg) {
    .btn, .user-menu {
      padding: 0.75rem 2.5rem;
    }
  }
}

#hamburger {
  color: #fff;
  display: none;
  float: right;
  font-size: $h25;
  line-height: $lh * 3;
  padding-top: 0.5rem;
  @media screen and (max-width: $res-sm) {
    display: inline-block;
  }
}

#topbar {
  @include trans;
  // background: #fff;
  // box-shadow: $s-sm;
  font-weight: 600;
  // font-family: $font-headline;
  padding: 0 1rem;
  position: absolute;
  width: 100%;
  z-index: 80;
  // &.sticky,
  &.float {
    background: #fff;
    // position: fixed;
    top: 0;
  }
  // &.sticky
  &.show-menu {
    background: #fff;
    box-shadow: $s-sm;
    // .main-logo {
    //   color: $c-main;
    //   &:active, &:focus, &:hover {
    //     color: $c-main;
    //   }
    // }
    #hamburger {
      color: $c-text;
    }
    #menu {
      padding: 0 0 1.5rem;
      // a, .btn {
      //   color: $c-link;
      //   &:hover {
      //     border-color: $c-link-hover;
      //     color: $c-link-hover;
      //   }
      //   &.router-link-active {
      //     color: #fff;
      //   }
      // }
    }
    #logo {
      color: $c-text;
    }
  }
  @media screen and (min-width: $res-md) {
    padding: 0 2rem;
  }
}

// #topbar-pad {
//   &.sticky {
//     height: 6rem;
//   }
// }

.main-logo {
  @include trans;
  color: $c-info;
  display: inline-block;
  font-weight: $semibold;
  font-size: $h3;
  padding: 0.5rem 0;
  > img {
    height: 60px;
  }
  > span {
    line-height: 60px;
    padding-left: 1rem;
    vertical-align: top;
  }
  &.router-link-exact-active {
    cursor: default;
  }
  &:active, &:focus, &:hover {
    color: $c-info-lightish;
  }
  @media screen and (min-width: $res-md) {
    font-size: $h2;
    padding: 1rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/Topbar.vue